module.exports = __webpack_public_path__ + "static/media/ic-remove.6ce78d14.svg";